import { Component, Input, AfterViewInit } from "@angular/core";
import { Router } from "@angular/router";

import { NavigationMenuItemMain } from "..";

@Component({
	selector: "sdp-navigation-menu-item",
	templateUrl: "./navigation-menu-item.component.html"
})

export class NavigationMenuItemComponent implements AfterViewInit {

	@Input()
	public item!: NavigationMenuItemMain;
	@Input()
	public isExpanded!: boolean;

	public isShowChild = true;
	public isEnabled = false;
	public readonly rotateIcon = { type: "material", name: "chevron_right", cssClass: "sdp-rotate-icon" };

	constructor(
		public router: Router
	) { }

	public ngAfterViewInit() {
		if (this.item.eventRegistration) {
			this.item.eventRegistration(this.item);
		}
	}

	public isSelectedPage(url: string): boolean {
		const selectedPage = this.router.url;
		return !!selectedPage && selectedPage.indexOf(url) >= 0;
	}

	public showChildren() {
		this.isShowChild = !this.isShowChild;
	}
}
